import { Box } from '#/components/Box/Box';
import type { CmsApiAnchorBlockData } from '#/modules/cms/api/types/blocks/CmsApiAnchorBlock';

type Props = {
  data: CmsApiAnchorBlockData;
};

export function CmsAnchorBlock({ data: { anchor } }: Props) {
  return (
    <Box
      component="a"
      qaId={`anchor-block-${anchor}`}
      id={anchor}
      className="anchor-block"
    />
  );
}
